import {Component, forwardRef, Input, OnInit} from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR, Validators, FormArray, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {UntilDestroy} from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';
import {
  createTwoDecimalInputMask,
  formControlErrorKeys,
  formControlErrorMessage,
  Mark
} from '@portal-workspace/grow-ui-library';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {AssetCategoryAndType, compareMatch, getAssetCategoriesAndTypes} from '@portal-workspace/grow-shared-library';
import {delay, distinctUntilChanged, tap} from 'rxjs/operators';
import numeral from 'numeral';
import {AssetTypeRateValue} from '@portal-workspace/grow-shared-library';
import {MARK} from '@portal-workspace/grow-ui-library/mark';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';



@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'asset-type-rate',
    templateUrl: './asset-type-rate.component.html',
    styleUrls: ['./asset-type-rate.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AssetTypeRateComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => AssetTypeRateComponent), multi: false },
    ],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule, MatInputModule, InputMaskModule, FlexModule, MatButtonModule]
})
export class AssetTypeRateComponent extends AbstractControlValueAccessor<AssetTypeRateValue> implements OnInit , Mark{

  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  @Input({required: true}) title?: string;
  @Input({required: false}) mandatory =false

  subscriptions: Subscription[] = [];

  catAndTypes:AssetCategoryAndType[] = getAssetCategoriesAndTypes();

  createTwoDecimalInputMask = createTwoDecimalInputMask();

  formArray: FormArray<FormGroup<{
    rate: FormControl<number | null>,
    type: FormControl<AssetCategoryAndType | null>,
  }>>;

  constructor(private formBuilder: FormBuilder) {
    super();
    this.formArray = formBuilder.array<FormGroup<{
      rate: FormControl<number | null>,
      type: FormControl<AssetCategoryAndType | null>,
    }>>([]);
  }

  add(v?: Exclude<AssetTypeRateValue, null>[number]) {
    const formControlRate: FormControl<number | null> = this.formBuilder.control(v && v.Rate ? v.Rate : 0, [Validators.required]);
    const o = v && v.Type ? this.catAndTypes.find(opt => opt.typeIndex === v.Type && opt.catIndex === v.Cat) : null;
    const formControlType: FormControl<AssetCategoryAndType | null> = this.formBuilder.control(o ?? null, [Validators.required]);
    const formGroup: FormGroup = this.formBuilder.group({
      rate: formControlRate,
      type: formControlType,
    });
    this.formArray.push(formGroup);
  }

  remove() {
    if (this.formArray.length > 0) {
      this.formArray.removeAt(this.formArray.length -1);
    }
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
    const sub = this.formArray.valueChanges.pipe(
      delay(0),
      distinctUntilChanged(compareMatch),
      tap(r => {
        console.log('****** asset type rate', this.formArray.valid);
        if (this.formArray.valid) {
          // NOTE: when formArray is valid, _r should not be null, as validators mandate their presence
          const o : Exclude<AssetTypeRateValue, null> = r.map((_r: any) => {
            return {
              Cat: _r.type!.catIndex,
              Type: _r.type!.typeIndex,
              Rate: numeral(_r.rate).value() ?? 0,
            }
          });
          console.log('***** asset type rate propagate', o);
          this.propagateChange(o);
        } else {
          console.log('***** asset type rate propagate', null);
          this.propagateChange(null);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);
  }

  doWriteValue(v: AssetTypeRateValue | null | undefined): void | AssetTypeRateValue {
    if (v) {
      for (const _v of v) {
        this.add(_v);
      }
    }
    return undefined;
  }

  formGroupControl(formGroup: AbstractControl, name: 'rate' | 'type'): FormControl<number | null> | FormControl<AssetCategoryAndType | null> {
    return (formGroup as FormGroup<{
      rate: FormControl<number | null>,
      type: FormControl<AssetCategoryAndType | null>,
    }>).controls[name] as FormControl<number | null> | FormControl<AssetCategoryAndType | null>;
  }

  onAdd($event: MouseEvent) {
    this.add();
  }

  onRemove($event: MouseEvent) {
    this.remove();
  }

  mark() {
    this.formArray.markAllAsTouched();
  }
}
